/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AccountNotes} from '../models/AccountNotes';
import type {Error} from '../models/Error';

export interface GetAccountNotes$Request {
    accountId: number;
}

export interface GetAccountNotes$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountNotesRequest = createAction<PayloadData<void, GetAccountNotes$Request>>('GET_ACCOUNT_NOTES__GET_ACCOUNT_NOTES__REQUEST');
export const getAccountNotesSuccess = createAction<PayloadData<AccountNotes, GetAccountNotes$Request>>('GET_ACCOUNT_NOTES__GET_ACCOUNT_NOTES__SUCCESS');
export const getAccountNotesFailure = createAction<PayloadData<Error, GetAccountNotes$Request, true>>('GET_ACCOUNT_NOTES__GET_ACCOUNT_NOTES__FAILURE');

export const getAccountNotesActions = [
    getAccountNotesRequest,
    getAccountNotesSuccess,
    getAccountNotesFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountNotes = (meta: GetAccountNotes$Request, config?: GetAccountNotes$Config) => {
    return {
        CALL_API: {
            types: getAccountNotesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/${meta.accountId}/notes`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

